import { render, staticRenderFns } from "./FormTNDisclosure.vue?vue&type=template&id=02ffdef0&scoped=true&"
import script from "./FormTNDisclosure.vue?vue&type=script&lang=js&"
export * from "./FormTNDisclosure.vue?vue&type=script&lang=js&"
import style0 from "./FormTNDisclosure.vue?vue&type=style&index=0&id=02ffdef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ffdef0",
  null
  
)

export default component.exports